<app-main-landing></app-main-landing>
<app-seller-landing *ngIf="false"></app-seller-landing>
<app-buyer-landing *ngIf="false"></app-buyer-landing>